import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/views/Layout.vue'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import ItemList from '@/views/ItemList.vue'
import Reconciliation from '@/views/Reconciliation.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: { title: '首页看板' } },
      { path: 'items', name: 'Items', component: ItemList, meta: { title: '商品记录' } },
      { path: 'reconciliation', name: 'Reconciliation', component: Reconciliation, meta: { title: '对账统计' } }
    ]
  },
  { path: '*', redirect: '/dashboard' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !store.state.token) {
    next('/login')
    return
  }
  if (to.path === '/login' && store.state.token) {
    next('/dashboard')
    return
  }
  next()
})

export default router